export * from './post-sync-azure-active-directory.service';
export * from './post-sync-azure-active-directory.service.module';